export { default as CompositeInput } from './CompositeInput';
export type { CompositeInputProps } from './CompositeInput.types';
